// extracted by mini-css-extract-plugin
export default {"input":"Input_input__J4lLI","input_placeholder":"Input_input_placeholder__ArDs3","input_text":"Input_input_text__Nl5dY","input_clear":"Input_input_clear__3o6mt"};